// extracted by mini-css-extract-plugin
export default {"login_button_google":"LoginButton_login_button_google__ZOBi5"};